import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=1e56cc38&scoped=true"
import script from "./addForm.vue?vue&type=script&lang=js"
export * from "./addForm.vue?vue&type=script&lang=js"
import style0 from "./addForm.vue?vue&type=style&index=0&id=1e56cc38&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e56cc38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e56cc38')) {
      api.createRecord('1e56cc38', component.options)
    } else {
      api.reload('1e56cc38', component.options)
    }
    module.hot.accept("./addForm.vue?vue&type=template&id=1e56cc38&scoped=true", function () {
      api.rerender('1e56cc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/increase_amount_activity/form/components/addForm.vue"
export default component.exports